import { render, staticRenderFns } from "./ColumnGrid.vue?vue&type=template&id=0fb0dc6a&"
import script from "./ColumnGrid.vue?vue&type=script&lang=js&"
export * from "./ColumnGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports